export const es = {
  navigation: {
    home: 'Inicio',
    aboutUs: 'Quiénes somos',
    ourWork: 'Nuestro Trabajo',
    ourServices: 'Servicios',
    ourProcess: 'Proceso',
    recognitions: 'Reconocimientos',
    newIdeas: 'Nuevos Proyectos',
  },
  hero: {
    title: '¿Cuál es nuestra labor?',
    subtitle: 'Descubre un lugar con aplicaciones increíbles y nuevos desarrollos',
    description: 'Somos una empresa tecnológica especializada en el desarrollo de soluciones digitales a medida. A lo largo de los años hemos realizado diferentes aportaciones en diversos campos.',
    innovation: 'Toda nuestra labor tiene un alto grado de innovación enfocada en el diseño de herramientas pensadas para facilitar la experiencia del usuario.',
    sectorsIntro: 'Hemos colaborado con compañías en la creación de herramientas para sectores especializados, tales como:',
    sectors: {
      biotech: 'Biotecnología',
      mentalHealth: 'Cuidado de la salud mental',
      music: 'Sector de la música',
      transport: 'Transporte',
      realEstate: 'Inmobiliario',
      agropharmaceutical: 'Agrofarmacéutico',
      general: 'Negocios en general'
    },
    closing: 'Impulsamos el crecimiento de tu empresa a través de la tecnología.'
  },
  aboutUs: {
    title: 'Quiénes somos',
    presence: {
      title: 'Colombia, nuestra base',
      description: 'Somos una empresa de desarrollo de software con base principal en Colombia, donde hemos construido la mayoría de nuestros proyectos a lo largo de los años.'
    },
    expansion: {
      title: 'Abriendo mercado en España',
      description: 'Actualmente estamos abriendo mercado en España, donde apoyamos el desarrollo web de TCG Madrid y participamos en la planeación de proyectos de Apptivities junto al Ayuntamiento de Madrid.'
    },
    team: {
      title: 'Un equipo pequeño y especializado',
      description: 'Contamos con dos desarrolladores de tiempo completo, y sumamos talento adicional según las necesidades de cada proyecto y cliente.'
    },
    locations: {
      colombia: 'Colombia',
      spain: 'España'
    }
  },
  features: {
    title: 'Ideas en aplicaciones',
    description: 'Nuestras aplicaciones son el reflejo de gustos personales y la sensacion de solucionar problemas y crear nuevas cosas.',
    items: {
      feature1: 'Aplicaciones nativas',
      feature2: 'Aplicaciones hibridas',
      feature3: 'Aplicaciones web',
    },
    summary: 'Ideas hechas aplicaciones en las cuales se pueden expresar de manera creativa.',
    summary2: 'Proyecto desarrollado en el sector de transporte que facilita realizar cálculos rápidos para la obtención de datos simples pero útiles.',
    images: {
      chart: 'Panel de estadísticas',
      calendar: 'Vista de calendario',
      graph: 'Gráfico analítico',
      metrics: 'Métricas de rendimiento'
    }
  },
  footer: {
    trial: {
      title: '¿Qué ideas convertidas en aplicaciones estarán por venir?',
      description: 'Muy pronto les estaremos mostrando los nuevos proyectos.',
      button: 'Contáctanos'
    },
    sections: {
      legal: {
        title: 'LEGAL',
        privacy: 'Política de Privacidad',
        licensing: 'Licencias',
        terms: 'Términos'
      }
    }
  },
  worldPotential: {
    title: "Reconocimientos",
    description: "Music Creator ha sido ganadora en los premios HMS App Innovation Contest en la versión 2021.",
    description2: "Melody Creator fue finalista en los premios Huawei de aplicaciones de 2019.",
    items: {
      item1: "Innovación en aplicaciones",
      item2: "Nuevos usos para hacer de la aplicación una herramienta más completa",
      item3: "Interfaz de usuario intuitiva y fácil de usar",
      item4: "Actualización constante",
      item5: "Mejorando la experiencia de usuario"
    },
    summary: "En la actualidad nuestras aplicaciones como Songs Creator y Melody Creator han alcanzado la cifra de hasta 500.000 descargas, lo cual es un gran logro. Así mismo, gracias a la pasión por el desarrollo de software, la curiosidad, las ideas y un ingrediente fundamental como es la mejora continua, podemos concluir que el mundo tecnológico está lleno de aventuras y posibilidades.",
    images: {
      worldMap: "World map statistics",
      lineChart: "Growth chart",
      usMap: "US map data"
    }
  },
  ourWork: {
    title: "Nuestro Trabajo",
    subtitle: "Proyectos innovadores que transforman ideas en soluciones reales",
    projects: {
      musicalArea: {
        title: "Área Musical",
        description: "Comenzando como una startup en 2016, ayudamos a DMB Mobile Apps a hacer crecer la aplicación Melody Creator hasta convertirla en una aplicación ampliamente utilizada con 500.000 descargas en la actualidad. A partir de esto también ayudamos a desarrollar dos aplicaciones más, Music Creator y Rhythm Creator, con buena recepción que actualmente están atrayendo usuarios.",
        location: "Colombia",
        highlights: [
          "Aplicaciones desarrolladas en lenguaje nativo para soportar todas las funciones de audio.",
          "Actualmente disponible en Google Play."
        ],
      },
      realEstate: {
        title: "Administración inmobiliaria",
        description: "En colaboración con LONJA se diseñó un sistema de evaluación y certificación de administradores de propiedad horizontal.",
        location: "Colombia, Estados Unidos",
        highlights: [
          "Sistema ágil, con reducción de tiempos en evaluación y creación de plantillas personalizadas."
        ]
      },
      mentalHealth: {
        title: "Cuidado de la salud mental",
        description: "Diseño e implementación de plataformas de telesalud; historia clínica unificada, gestión de citas con profesionales y plataformas con una UX efectiva. Estas herramientas permitieron mejores tiempos de atención y la expansión del mercado a través de medios digitales.",
        location: "Colombia",
        highlights: [
          "Desarrollo de aplicaciones para seguimiento clínico y bienestar mental.",
          "Cumplimiento en la regulación sanitaria en Colombia."
        ]
      },
      biotech: {
        title: "Biotecnología",
        description: "Con nuestro apoyo en el sector Biotecnología se mejoró la aplicación para la obtención de datos y análisis de un dispositivo automático de diagnóstico de covid-19.",
        location: "Estados Unidos",
        highlights: [
          "Mejora la infraestructura y configuración de servicios en la nube de la empresa.",
          "Reducción de costos del 40% y optimizando recursos para el análisis de muestras."
        ]
      },
      zonari: {
        title: "Zonari — Administración de parqueaderos",
        description: "Zonari es nuestra plataforma SaaS recién lanzada en Colombia para la administración de parqueaderos en conjuntos residenciales, con control de acceso por roles para administradores, residentes y usuarios autorizados.",
        location: "Colombia",
        highlights: [
          "Gestión y auditoría de accesos en tiempo real.",
          "Infraestructura segura y escalable en la nube."
        ]
      },
      tcgmadrid: {
        title: "TCG Madrid — Tienda especializada",
        description: "Apoyamos el desarrollo de la tienda online de TCG Madrid, referente en la venta de cartas coleccionables (Magic, Pokémon, One Piece) en España, con catálogo, control de autenticidad y gestión de torneos.",
        location: "España",
        highlights: [
          "Plataforma de e-commerce con catálogo y envíos a toda España.",
          "Nuestro primer proyecto de desarrollo web en el mercado español."
        ]
      },
      apptivities: {
        title: "Apptivities — Planeación de actividades con IA",
        description: "Colaboramos en la planeación del proyecto Apptivities, una aplicación de inteligencia artificial para la creación de itinerarios de ocio personalizados, en articulación con el Ayuntamiento de Madrid.",
        location: "España",
        highlights: [
          "Itinerarios generados con IA en minutos en lugar de horas.",
          "Proyecto clave en nuestra expansión hacia España."
        ]
      }
    }
  },
  ourProcess: {
    title: "Nuestro Proceso",
    steps: {
      step1: {
        title: "Paso 1",
        description: "Análisis de necesidades y recopilación de requisitos con personal experto"
      },
      step2: {
        title: "Paso 2",
        description: "Generación de cotización personalizada y validación con el cliente"
      },
      step3: {
        title: "Paso 3",
        description: "Desarrollo y validación del progreso mediante revisiones periódicas continuas con nuestros clientes"
      },
      step4: {
        title: "Paso 4",
        description: "Entrega final y verificación de implementación"
      },
      step5: {
        title: "Paso 5",
        description: "Servicio de soporte y acompañamiento"
      }
    }
  },
  ourServices: {
    title: "Nuestros Servicios",
    services: {
      software: {
        title: "Desarrollo de Software",
        description: "Soluciones personalizadas adaptadas a sus necesidades específicas"
      },
      mobile: {
        title: "Aplicaciones Móviles",
        description: "Desarrollo de apps nativas y multiplataforma"
      },
      cloud: {
        title: "Servicios Cloud",
        description: "Soluciones en la nube escalables y seguras"
      },
      itSupport: {
        title: "Administración y soporte en servicios IT",
        description: "Adaptamos tu infraestructura a las necesidades de tu empresa ahorrando tiempo y recursos."
      },
      consulting: {
        title: "Consultoría y asesoría en tecnologías",
        description: "Asesoramiento en la elección y aplicación de tecnologías que optimicen el rendimiento de tu empresa."
      }
    }
  },
  legal: {
    tocLabel: 'Índice',
    backToTop: '↑ Volver arriba'
  },
  cookieBanner: {
    ariaLabel: 'Aviso de cookies',
    message: 'Este sitio no utiliza cookies de seguimiento, publicidad ni analítica. Solo usamos el almacenamiento local de tu navegador para recordar que ya viste este aviso.',
    learnMore: 'Saber más',
    acknowledge: 'Entendido'
  },
  privacyPolicy: {
    title: 'Política de Privacidad',
    lastUpdated: 'Última actualización: 9 de septiembre de 2026',
    sections: [
      {
        id: 'responsibleParty',
        heading: 'Responsable del tratamiento',
        paragraphs: [
          "Esta Política de Privacidad aplica al sitio web corporativo de JBP Software SAS (\"JBP Software\", \"nosotros\" o \"la empresa\"), una empresa de desarrollo de software con domicilio principal en Colombia y presencia comercial en expansión en España.",
          "El responsable del tratamiento de los datos personales que se recolectan a través de este sitio es JBP Software SAS. Para cualquier consulta relacionada con esta política puedes escribirnos a jbp.software.sas@gmail.com."
        ]
      },
      {
        id: 'dataCollected',
        heading: 'Información que recopilamos',
        paragraphs: [
          "Este sitio web es una página de presentación corporativa y actualmente no cuenta con formularios de registro, cuentas de usuario ni herramientas de analítica o cookies de seguimiento activas.",
          "Los únicos datos personales que recopilamos son los que tú decides entregarnos de forma voluntaria al contactarnos, por ejemplo:"
        ],
        list: [
          "Nombre, correo electrónico y el contenido del mensaje cuando escribes a nuestro correo de contacto (jbp.software.sas@gmail.com).",
          "Tu número de teléfono y el contenido de la conversación cuando nos escribes a través del botón de WhatsApp disponible en el sitio.",
          "Datos técnicos básicos que el proveedor de hosting pueda registrar automáticamente al visitar el sitio (como dirección IP o tipo de navegador), utilizados únicamente con fines de seguridad y funcionamiento del servicio."
        ]
      },
      {
        id: 'useOfData',
        heading: 'Cómo usamos la información',
        paragraphs: [
          "Usamos la información que nos compartes exclusivamente para:"
        ],
        list: [
          "Responder tus consultas comerciales o técnicas.",
          "Dar seguimiento a solicitudes de cotización o de servicios de desarrollo de software.",
          "Mantener comunicación contigo sobre un proyecto o relación comercial en curso."
        ]
      },
      {
        id: 'dataSharing',
        heading: 'Con quién compartimos la información',
        paragraphs: [
          "No vendemos, alquilamos ni cedemos tus datos personales a terceros con fines comerciales.",
          "Cuando nos escribes por WhatsApp, la conversación se procesa a través de la infraestructura de WhatsApp/Meta, que actúa como proveedor del canal de mensajería y trata la información conforme a su propia política de privacidad.",
          "Podríamos divulgar información personal cuando sea estrictamente necesario para cumplir con una obligación legal o un requerimiento de una autoridad competente."
        ]
      },
      {
        id: 'dataRetention',
        heading: 'Conservación de los datos',
        paragraphs: [
          "Conservamos la información que nos compartes únicamente durante el tiempo necesario para atender tu solicitud o mantener la relación comercial correspondiente, y posteriormente durante el plazo que exija la ley aplicable. Una vez cumplida su finalidad, procuramos eliminarla o anonimizarla de forma segura."
        ]
      },
      {
        id: 'security',
        heading: 'Seguridad de la información',
        paragraphs: [
          "Aplicamos medidas razonables de seguridad, técnicas y organizativas, para proteger la información personal que manejamos frente a accesos no autorizados, pérdida o uso indebido. Sin embargo, ningún medio de transmisión o almacenamiento electrónico es completamente infalible, por lo que no podemos garantizar una seguridad absoluta."
        ]
      },
      {
        id: 'rights',
        heading: 'Derechos del titular de los datos',
        paragraphs: [
          "Si te encuentras en Colombia, tienes los derechos reconocidos por la Ley 1581 de 2012 y el Decreto 1377 de 2013 (régimen de protección de datos personales - Habeas Data), entre ellos:"
        ],
        list: [
          "Conocer, actualizar y rectificar tus datos personales.",
          "Solicitar prueba de la autorización otorgada para el tratamiento de tus datos, cuando aplique.",
          "Solicitar la supresión de tus datos cuando su tratamiento no respete los principios, derechos y garantías constitucionales y legales.",
          "Revocar la autorización otorgada para el tratamiento de tus datos personales.",
          "Presentar quejas ante la Superintendencia de Industria y Comercio por infracciones a la normativa de protección de datos."
        ]
      },
      {
        id: 'euReference',
        heading: 'Visitantes desde España y la Unión Europea',
        paragraphs: [
          "Dado que estamos ampliando nuestra actividad comercial hacia España, si nos visitas o contactas desde España o cualquier país de la Unión Europea, procuramos aplicar principios equivalentes a los establecidos por el Reglamento General de Protección de Datos (RGPD/GDPR) y la Ley Orgánica 3/2018 de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD), en particular en cuanto a la licitud, minimización y transparencia en el tratamiento de tus datos.",
          "Si consideras que tus derechos bajo esta normativa no han sido respetados, puedes contactarnos directamente a través del correo indicado en esta política antes de acudir a la autoridad de control correspondiente."
        ]
      },
      {
        id: 'minors',
        heading: 'Menores de edad',
        paragraphs: [
          "Este sitio web está dirigido a un público empresarial y profesional, y no está diseñado para ser utilizado por menores de edad. No recopilamos de forma consciente información personal de menores de 18 años. Si tienes conocimiento de que un menor nos ha proporcionado datos personales, contáctanos para proceder a eliminarlos."
        ]
      },
      {
        id: 'internationalTransfers',
        heading: 'Transferencia internacional de datos',
        paragraphs: [
          "En el marco de nuestra expansión hacia España, es posible que la información que compartes se procese o almacene tanto en Colombia como en España, o en servidores de proveedores de servicios en la nube ubicados en otros países. En estos casos, adoptamos medidas razonables para que dichos datos reciban un nivel de protección adecuado, conforme a la normativa aplicable en cada jurisdicción."
        ]
      },
      {
        id: 'changes',
        heading: 'Cambios a esta política',
        paragraphs: [
          "Podemos actualizar esta Política de Privacidad para reflejar cambios en nuestras prácticas, en nuestros servicios o en la normativa aplicable. La fecha de la última actualización se indica al inicio de este documento. Te invitamos a revisar esta página periódicamente."
        ]
      },
      {
        id: 'cookies',
        heading: 'Cookies y almacenamiento local',
        paragraphs: [
          "Este sitio web no utiliza cookies de seguimiento, publicidad ni analítica, y no recopilamos datos de navegación con fines estadísticos o de marketing.",
          "Usamos el almacenamiento local de tu navegador únicamente para recordar que ya viste el aviso de cookies de este sitio, de modo que no vuelva a aparecer en visitas futuras. Esta información permanece en tu dispositivo y nunca se envía a nuestros servidores ni a terceros."
        ]
      },
      {
        id: 'contact',
        heading: 'Contacto',
        paragraphs: [
          "Si tienes preguntas sobre esta Política de Privacidad o sobre el tratamiento de tus datos personales, puedes escribirnos a jbp.software.sas@gmail.com."
        ]
      }
    ]
  },
  termsAndConditions: {
    title: 'Términos y Condiciones',
    lastUpdated: 'Última actualización: 9 de septiembre de 2026',
    sections: [
      {
        id: 'acceptance',
        heading: 'Aceptación de los términos',
        paragraphs: [
          "Al acceder y utilizar el sitio web de JBP Software SAS (\"el sitio\") aceptas los presentes Términos y Condiciones en su totalidad. Si no estás de acuerdo con alguno de estos términos, te pedimos abstenerte de utilizar el sitio."
        ]
      },
      {
        id: 'purpose',
        heading: 'Objeto del sitio',
        paragraphs: [
          "Este sitio tiene como finalidad presentar a JBP Software SAS, una empresa de desarrollo de software con base en Colombia y presencia comercial en expansión en España, así como dar a conocer sus servicios, procesos de trabajo y proyectos representativos (\"Nuestro Trabajo\").",
          "La información publicada en el sitio tiene fines informativos y no constituye una oferta comercial vinculante ni un contrato de prestación de servicios; cualquier relación contractual con JBP Software SAS se formalizará mediante acuerdos específicos con cada cliente."
        ]
      },
      {
        id: 'permittedUse',
        heading: 'Uso permitido del sitio',
        paragraphs: [
          "Te comprometes a utilizar el sitio de forma lícita, absteniéndote de:"
        ],
        list: [
          "Utilizar el sitio con fines fraudulentos, ilícitos o contrarios a la buena fe.",
          "Intentar vulnerar la seguridad del sitio o acceder a áreas restringidas sin autorización.",
          "Reproducir, copiar o distribuir contenidos del sitio con fines comerciales sin autorización previa."
        ]
      },
      {
        id: 'intellectualProperty',
        heading: 'Propiedad intelectual',
        paragraphs: [
          "Los contenidos del sitio (textos, imágenes, logotipos, diseño y código fuente) son propiedad de JBP Software SAS o de sus licenciantes y están protegidos por la normativa de propiedad intelectual aplicable. Queda prohibida su reproducción, distribución o modificación total o parcial sin autorización previa y escrita de JBP Software SAS."
        ]
      },
      {
        id: 'thirdPartyBrands',
        heading: 'Marcas y proyectos de terceros',
        paragraphs: [
          "En la sección \"Nuestro Trabajo\" mencionamos y mostramos logotipos de clientes y proyectos en los que hemos participado, tales como TCG Madrid, Apptivities y Zonari, entre otros. Las marcas, nombres comerciales y logotipos de terceros son propiedad de sus respectivos titulares y se exhiben únicamente con fines demostrativos e informativos de nuestro portafolio de trabajo, sin que ello implique afiliación, patrocinio o respaldo alguno salvo que se indique expresamente."
        ]
      },
      {
        id: 'thirdPartyLinks',
        heading: 'Enlaces y servicios de terceros',
        paragraphs: [
          "El sitio incluye un enlace directo a WhatsApp para facilitar el contacto con nosotros. Este servicio es operado por un tercero (Meta) y su uso está sujeto a los términos y políticas de dicho proveedor, sobre los cuales no tenemos control ni responsabilidad."
        ]
      },
      {
        id: 'accuracy',
        heading: 'Exactitud de la información',
        paragraphs: [
          "Nos esforzamos por mantener la información del sitio actualizada y correcta, pero no garantizamos que esté siempre libre de errores, completa o vigente en todo momento. La información publicada puede modificarse sin previo aviso."
        ]
      },
      {
        id: 'liability',
        heading: 'Limitación de responsabilidad',
        paragraphs: [
          "En la medida permitida por la ley, JBP Software SAS no será responsable por daños directos o indirectos derivados del uso o la imposibilidad de uso del sitio, incluyendo interrupciones del servicio, errores u omisiones en el contenido, o el uso de enlaces a sitios de terceros."
        ]
      },
      {
        id: 'governingLaw',
        heading: 'Ley aplicable y jurisdicción',
        paragraphs: [
          "Estos Términos y Condiciones se rigen por las leyes de la República de Colombia, país de domicilio principal de JBP Software SAS. Para relaciones comerciales específicas con clientes ubicados en España u otros países, podrán pactarse términos contractuales adicionales que consideren la normativa local aplicable."
        ]
      },
      {
        id: 'changes',
        heading: 'Modificaciones a estos términos',
        paragraphs: [
          "Podemos actualizar estos Términos y Condiciones en cualquier momento para reflejar cambios en nuestros servicios o en la normativa aplicable. La fecha de la última actualización se indica al inicio de este documento."
        ]
      },
      {
        id: 'contact',
        heading: 'Contacto',
        paragraphs: [
          "Si tienes preguntas sobre estos Términos y Condiciones, puedes escribirnos a jbp.software.sas@gmail.com."
        ]
      }
    ]
  }
}